export const queryKeys = {
  campaigns: {
    all: ['campaigns'] as const,
    purchases: (id: string) => ['campaigns', id, 'purchases'] as const,
    sales: (id: string) => ['campaigns', id, 'sales'] as const,
    pnl: (id: string) => ['campaigns', id, 'pnl'] as const,
    inventory: (id: string) => ['campaigns', id, 'inventory'] as const,
    expectedValues: (id: string) => ['campaigns', id, 'expectedValues'] as const,
  },
  credit: {
    summary: ['credit', 'summary'] as const,
    config: ['credit', 'config'] as const,
    invoices: ['credit', 'invoices'] as const,
  },
  portfolio: {
    health: ['portfolio', 'health'] as const,
    channelVelocity: ['portfolio', 'channelVelocity'] as const,
    insights: ['portfolio', 'insights'] as const,
    suggestions: ['portfolio', 'suggestions'] as const,
    weeklyReview: ['portfolio', 'weeklyReview'] as const,
    revocations: ['portfolio', 'revocations'] as const,
    globalInventory: ['portfolio', 'globalInventory'] as const,
  },
  admin: {
    allowlist: ['admin', 'allowlist'] as const,
    users: ['admin', 'users'] as const,
    apiUsage: ['admin', 'apiUsage'] as const,
    pricingDiagnostics: ['admin', 'pricingDiagnostics'] as const,
    priceOverrideStats: ['admin', 'priceOverrideStats'] as const,
    priceFlags: (status: string) => ['admin', 'priceFlags', status] as const,
    cardLadderStatus: ['admin', 'cardLadderStatus'] as const,
    cardLadderFailures: ['admin', 'cardLadderFailures'] as const,
    dhStatus: ['admin', 'dhStatus'] as const,
    dhPushConfig: ['admin', 'dhPushConfig'] as const,
    dhUnmatched: ['admin', 'dhUnmatched'] as const,
    psaSyncStatus: ['admin', 'psaSyncStatus'] as const,
    dhTombstoneCount: ['admin', 'dhTombstoneCount'] as const,
  },
  purchases: {
    psaPendingItems: ['purchases', 'psaPendingItems'] as const,
  },
  certs: {
    lookup: (certNumber: string) => ['certs', certNumber] as const,
  },
  psaCampaigns: { list: ['psa-campaigns', 'list'] as const },
  psaPushes: { list: ['psa-pushes', 'list'] as const },
  psaSubjects: { list: ['psa-subjects', 'list'] as const },
} as const;
